<div class="upload-panel" *ngIf="!(src$ | async)">
  <div class="description" trans>Upload a thumbnail for this link.</div>
  <button
    type="button"
    mat-flat-button
    color="accent"
    class="action-button"
    (click)="openUploadWindow()"
    trans
  >
    Upload Thumbnail
  </button>
</div>

<div class="change-panel" *ngIf="src$ | async">
  <img [src]="src$ | async" alt="" class="preview">
  <div class="upload-buttons">
    <button
      type="button"
      mat-flat-button
      color="accent"
      class="action-button change-button"
      (click)="openUploadWindow()"
      trans
    >
      Change
    </button>
    <button
      type="button"
      mat-stroked-button
      color="accent"
      class="action-button"
      (click)="removeImage()"
      trans
    >
      Remove
    </button>
  </div>
</div>
